import React from "reactn";
import styled from "styled-components";

export const ErrorMessage = ({ errors }) => {
	const e = [].concat(errors).map((err) => <li>{err}</li>);
	return (
		<Error>
			<h5>Error</h5>
			{e.length > 1 && e}
			{e.length === 1 &&
				[].concat(errors).reduce((_, err) => <p>{err}</p>)}
		</Error>
	);
};

const Error = styled.div`
	padding: 1.6rem;
	line-height: 1.6rem;
	background-color: #f8d7da;
	color: #721c24;
	border-left: 5px solid #f5c6cb;
`;
